// src/config/antiSnipingConfig.js
// Configuración centralizada del sistema anti-sniping
// Evita pujas de último segundo extendiendo el deadline automáticamente

/**
 * Umbral en minutos para activar anti-sniping
 * Si quedan menos de X minutos cuando se hace una puja, se extiende el tiempo
 */
export const ANTI_SNIPING_THRESHOLD = 4;

/**
 * Minutos que se extiende el deadline cuando se activa anti-sniping
 * El nuevo deadline será: momento_de_la_puja + EXTENSION minutos
 */
export const ANTI_SNIPING_EXTENSION = 4;

// Límite máximo de extensión en minutos
export const ANTI_SNIPING_MAX_EXTENSION = 60;

export default {
  ANTI_SNIPING_THRESHOLD,
  ANTI_SNIPING_EXTENSION,
  ANTI_SNIPING_MAX_EXTENSION,
};